// src/api/caseStudyApi.js
import { apiClient, getAuthHeader } from "./apiConfig";

// Fetch all case studies with optional filters (e.g., type: 'case' | 'blog')
export const fetchCaseStudies = async () => {
  const res = await apiClient.get(`/case-studies`, {
    ...getAuthHeader(),
  });
  return res.data?.data || [];
};

// Create case study (with file upload)
export const createCaseStudy = async (payload) => {
  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(key, value);
    }
  });

  return await apiClient.post(`/case-studies/create`, formData, {
    ...getAuthHeader(),
    headers: {
      ...getAuthHeader().headers,
      "Content-Type": "multipart/form-data",
    },
  });
};

// Update case study (multipart POST)
export const updateCaseStudy = async (id, payload) => {
  const formData = new FormData();
  Object.entries(payload).forEach(([k, v]) => {
    if (v !== undefined && v !== null) formData.append(k, v);
  });

  return apiClient.post(`/case-studies/update/${id}`, formData, {
    ...getAuthHeader(),
    headers: {
      ...getAuthHeader().headers,
      "Content-Type": "multipart/form-data",
    },
  });
};

// Delete case study
export const deleteCaseStudy = async (id) => {
  return await apiClient.delete(`/case-studies/${id}`, getAuthHeader());
};
